import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

import "./DashboardLayout.scss";

const DashboardLayout = () => {
  return (
    <div className="dashboard-layout-root">
      <Navbar />
      <Outlet />
    </div>
  );
};

export default DashboardLayout;
